import { Http, Tools, Type } from 'me-view/lib/script/index'
import { Message } from 'me-view'
import util from '@common/util'

const resolve = response => {
  console.debug('http --> response：', response)
  const { data, headers } = response

  const authorization = Reflect.get(headers || {}, 'authorization')
  if (Tools.notEmpty(authorization)) {
    util.authorization = authorization
    util.synchronizeSession(/** 通知其他系统同步会话 */)
  }

  if (Type.isBlog(data)) {
    // 支持二进制下载
    console.debug('http --> data is blog：', data)
    return data
  }

  if (Type.isString(data)) {
    console.debug('http --> data is string：', data)
    return data
  }

  if (Type.isObject(data)) {
    const { code, success } = data
    console.debug('http --> data is object：', data)
    if (Tools.notEmpty(code)) {
      if (code === 'SUCCESS' || success === true) {
        return data.data
      }

      if (code.startsWith('TOKEN_')) {
        return util.systemLogout()
      }

      if (code === 'LOGIN_AUTHORITY') {
        Message.warning('该资源无权访问。')
      }

      if (code === 'ERROR_UNKNOWN') {
        console.error('未知异常', '->', data.message)
      }
    }
  }

  console.debug('http --> data error：', data)
  return Promise.reject({ data, headers, response })
}

class ExtendHttp extends Http {
  static JSON = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }

  static FORM = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest'
  }

  static HEADER_JSON = {
    headers: { ...ExtendHttp.JSON }
  }

  static HEADER_FORM = {
    headers: { ...ExtendHttp.FORM }
  }

  constructor ({ baseURL, timeout, headers } = { timeout: 1000, baseURL: '/api' }) {
    super({ baseURL, timeout, headers })
    console.debug('YtoHttp extends Http constructor')
    this.initInterceptorRequest()
    super.initInterceptorResponse({ resolve })
  }

  initInterceptorRequest () {
    super.initInterceptorRequest({
      resolve (options) {
        if (Tools.isEmpty(options.headers)) {
          Reflect.set(options, 'headers', { })
        }
        Object.assign(options.headers, {
          authorization: util.authorization,
          portal_source: util.sourceCurrent
        })
        return options
      }
    })
  }

  initHttp ({ baseURL, timeout, headers } = { timeout: 1000, baseURL: '/api' }) {
    console.debug('YtoHttp initHttp')
    super.initHttp({ baseURL, timeout, headers })
  }
}

export { ExtendHttp }

export default new ExtendHttp()
